import { render } from "./ServiceDetailSkeleton.vue?vue&type=template&id=25164a39&scoped=true"
import script from "./ServiceDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./ServiceDetailSkeleton.vue?vue&type=script&lang=js"

import "./ServiceDetailSkeleton.vue?vue&type=style&index=0&id=25164a39&scoped=true&lang=css"

import exportComponent from "/home/runcloud1user/webapps/brightflame/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25164a39"]])

export default __exports__